<a class="btn btn-action btn-small btn-back back-navigation" [routerLink]="{ cxRoute: 'dispenserAgreements' } | cxUrl">
  <i class="fas fa-arrow-left mr-1"></i> {{ 'shared.backTo.dispensers' | cxTranslate }}
</a>

@if (isReviewing) {
  <div class="container">
    <mat-card class="new-dispenser-agreement__body">
      <h3 class="new-dispenser-agreement__body__title">
        {{ 'dispenserAgreement.requestSubmitted' | cxTranslate }}
      </h3>
      <p class="newLine">{{ 'dispenserAgreement.updateMessage' | cxTranslate }}</p>
      <p class="newLine">{{ 'dispenserAgreement.updateAgreementMessage' | cxTranslate }}</p>
      <div class="action-button">
        <button class="btn btn-primary" (click)="backToHistory()">
          {{ 'dispenserAgreement.checkStatusButton' | cxTranslate }}
        </button>
      </div>
    </mat-card>
  </div>
} @else {
  <mat-horizontal-stepper labelPosition="bottom" #stepper>
    <mat-step [stepControl]="assetSelectionFormGroup">
      <form [formGroup]="assetSelectionFormGroup">
        <ng-template matStepLabel>
          <label class="description-title">{{ 'dispenserAgreement.assetSelection' | cxTranslate }}</label>
        </ng-template>
        <mat-card class="new-dispenser-agreement__body">
          <h3>{{ 'dispenserAgreement.assetSelection' | cxTranslate }}</h3>
          <p class="new-dispenser-agreement__body__title">
            {{ 'dispenserAgreement.dispenserDisclaimer' | cxTranslate }}
          </p>
          <div class="new-dispenser-agreement__body__section">
            <div class="new-dispenser-agreement__body__section__content">
              <div class="form-group col-6 col-md-6 col-lg-6">
                <div class="input-group mr-1">
                  <input
                    tabindex="1"
                    class="form-control search-input"
                    formControlName="searchText"
                    placeholder="Search Assets"
                    [ngClass]="{ roundCorner: !assetSelectionFormGroup.controls.searchText.value }"
                    />
                    <div class="input-group-append">
                      @if (assetSelectionFormGroup.controls.searchText.value) {
                        <span
                          class="input-group-text"
                          (click)="getSearchText().reset()"
                          >
                          <i class="fa fa-times"></i>
                        </span>
                      }
                    </div>
                    <button class="btn btn-primary ml-2" (click)="searchAssets(assetSelectionFormGroup.value.searchText)">
                      Search
                    </button>
                  </div>
                </div>
                <div class="form-group col-12 col-md-12 col-lg-12">
                  @if (errorMessage) {
                    <div class="alert-danger error-alert" role="alert">
                      <i class="fas fa-info-circle info-icon" triggers="mouseenter:mouseleave"></i>
                      {{ errorMessage }}
                    </div>
                  }
                </div>
              </div>
              <div class="new-dispenser-agreement__body__section__content">
                @if (!(isLoading$ | async)) {
                  <div class="address-panel col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    @if (categoryProducts.size > 0) {
                      <mat-accordion multi>
                        @for (category of categoryProducts | keyvalue; track category) {
                          <mat-expansion-panel [expanded]="false">
                            <mat-expansion-panel-header>
                              <mat-panel-title>{{ category.key }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row">
                              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <app-custom-table
                                  [headers]="headers"
                                  [columns]="columns"
                                  override="DispenserAgreementProductRows"
                                  rowId="code"
                                  [rows]="categoryProducts.get(category.key)"
                                  (changeValue)="updateProductQuantity($event, category.key)"
                                  >
                                </app-custom-table>
                                <ng-template #NoEntries>
                                  <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
                                </ng-template>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        }
                      </mat-accordion>
                    } @else {
                      <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
                    }
                  </div>
                }
                <div class="action-button">
                  <button class="btn btn-primary" mat-button matStepperNext [disabled]="disableAssetSelectionNextStep">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </mat-card>
        </form>
      </mat-step>
      <mat-step [stepControl]="termInformationFormGroup">
        <form [formGroup]="termInformationFormGroup">
          <ng-template matStepLabel>
            <label class="description-title">{{ 'dispenserAgreement.termInformation' | cxTranslate }}</label>
          </ng-template>
          <mat-card class="new-dispenser-agreement__body">
            <h3 class="new-dispenser-agreement__body__title">
              {{ 'dispenserAgreement.termInfo' | cxTranslate }}
            </h3>
            <div class="new-dispenser-agreement__body__section">
              <div class="new-dispenser-agreement__body__section__content">
                <div class="form-group row">
                  <p class="newLine mb-2 col col-md-10 col-lg-8">
                    {{ 'dispenserAgreement.termInfoMessage' | cxTranslate: { dispenser: 'Essity Australasia' } }}
                  </p>
                  <div class="form-check col-12 ml-3">
                    <input
                      formControlName="accept"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                      />
                      <label class="form-check-label" for="defaultCheck1">
                        {{ 'dispenserAgreement.yesNo' | cxTranslate }}</label
                        >
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col col-md-10 col-lg-8">
                        <div class="form-group-control term-information-comment">
                          <span class="label-content reject-reason-label">{{ 'shared.comments' | cxTranslate }}</span>
                          <textarea
                            class="form-control term-information-comment-input"
                            formControlName="comments"
                            rows="2"
                            maxlength="200"
                            placeholder="{{ 'shared.commentPlaceHolder' | cxTranslate }}"
                          ></textarea>
                        </div>
                        <div class="term-information-comment-limit">
                          {{ 200 - termInformationFormGroup.controls?.comments?.value.length }} / 200
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="new-dispenser-agreement__body__section__content">
                    <div class="action-button">
                      <button matStepperPrevious class="btn back-button btn-action">Back</button>
                      <button matStepperNext class="btn btn-primary" [disabled]="disableTermInformation">Next</button>
                    </div>
                  </div>
                </div>
              </mat-card>
            </form>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>
              <label class="description-title">{{ 'dispenserAgreement.review' | cxTranslate }}</label>
            </ng-template>
            <mat-card class="new-dispenser-agreement__body">
              <h3 class="new-dispenser-agreement__title">
                {{ 'dispenserAgreement.review' | cxTranslate }}
              </h3>
              <div class="new-dispenser-agreement__body__section">
                @if (requesterInformation) {
                  <mat-card class="new-dispenser-agreement__header">
                    <div class="row">
                      <div class="col-md-6">
                        <h4 class="new-dispenser-agreement__body__title">
                          {{ 'dispenserAgreement.requesterInformation' | cxTranslate }}
                        </h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.requesterName' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.addressLine1' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ requesterInformation.requesterName }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ requesterInformation.adressLine1 }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.distributionCompany' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.addressLine2' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ requesterInformation.distributionCompany }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ requesterInformation.adressLine2 }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.abn' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.postcode' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ requesterInformation.abn }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ requesterInformation.postalCode }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'shared.email' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.state' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ requesterInformation.email }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ requesterInformation.state }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.phoneNumber' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ requesterInformation.phoneNumber }}</div>
                      </div>
                    </div>
                  </mat-card>
                }
                @if (endCustomerInformation) {
                  <mat-card class="new-dispenser-agreement__header">
                    <div class="row">
                      <div class="col-md-6">
                        <h4 class="new-dispenser-agreement__body__title">
                          {{ 'dispenserAgreement.endCustomerInformation' | cxTranslate }}
                        </h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.businessName' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.addressLine1' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.businessName }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.adressLine1 }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.contactName' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.addressLine2' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.contactName }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.adressLine2 }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'shared.email' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.postcode' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.email }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.postCode }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.phoneNumber' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.state' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.phoneNumber }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.state }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.installer' | cxTranslate }}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="description-text">
                          {{ 'dispenserAgreement.installReason' | cxTranslate }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.installer }}</div>
                      </div>
                      <div class="col-md-4">
                        <div>{{ endCustomerInformation.installReason }}</div>
                      </div>
                    </div>
                  </mat-card>
                }
                <mat-card class="new-dispenser-agreement__header">
                  <div class="row">
                    <div class="col-md-6">
                      <h4 class="new-dispenser-agreement__body__title">
                        {{ 'dispenserAgreement.agreementType' | cxTranslate }}
                      </h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="agreement-type">{{ DispenserTypeEnum[agreementFolType] }}</div>
                      @for (category of categoryProducts | keyvalue; track category) {
                        <div class="ml-3">
                          @for (product of category.value; track product) {
                            <div class="ml-3">
                              @if (product.quantity) {
                                <div>{{ product.quantity }} x {{ product.name }}</div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </mat-card>
                <mat-card class="new-dispenser-agreement__header">
                  <div class="row">
                    <div class="col-md-6">
                      <h4 class="new-dispenser-agreement__body__title">
                        {{ 'dispenserAgreement.termInformation' | cxTranslate }}
                      </h4>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-4">
                      <div>{{ 'dispenserAgreement.confirmTermInformation' | cxTranslate }}</div>
                    </div>
                  </div>
                </mat-card>
              </div>
              <div class="action-button">
                <button mat-button matStepperPrevious class="btn back-button btn-action">Back</button>
                <button mat-button matStepperNext class="btn btn-primary" (click)="submitDispenserAgreementUpdate()">
                  Submit
                </button>
              </div>
            </mat-card>
          </mat-step>
        </mat-horizontal-stepper>
      }


      @if (requestError$ | async) {
        <div class="mt-5 mb-5">
          <app-custom-error [errorMessage]="'shared.errorTryAgain' | cxTranslate"></app-custom-error>
        </div>
      }


      @if (isLoading$ | async) {
        <div class="cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
      }
